<p-menubar [model]="items" styleClass="top-bar">
    <label *ngIf="profile" class="user-name">{{profile?.name}}</label>
    <button pButton class="button-logout" label="Logout" icon="pi pi-power-off" (click)="logout()"></button>
</p-menubar>
<div class="page-container">
    <router-outlet></router-outlet>
</div>
